import "./registrationDetailsHit.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { authKey, GET_ADDRESS_BY_IFSC, ResourceUpdateMember } from '../../../../common/URLs';
import jwt from 'jwt-decode';

import moment from 'moment';
import resolveIcon from "../../../../images/resolved.png";
import { CheckCircle as TickIcon, Search as SearchIcon, Cancel as CrossIcon, ArrowForwardIosSharp as AccordionIcon } from '@mui/icons-material';
import { loaderService } from "../../../../common/custom-loader/loader-service"
import { Button, Switch, FormGroup, FormControlLabel, Container, Divider, Card, CardContent, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, FormLabel, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { maxNameLength, accountNumberLimit, emailValidation, nameValidation, typeNumberValid, VALIDATION, lastFourDigit } from "../../../../common/commonValidations";
import { ROLES, CONSTANTS, BLOCK_LIST, REVENUE_CIRCLE, BANK_CANCELLED_CHEQUE, EMPTY_FIELD_ERROR, SALUTATION, UPLOAD_FILE_TEXT, BASIC_DATE_FORMAT, GENDER, API_DATE_FORMAT, RESOURCE_ROLES } from "../../../../common/constants";
import { sendOTP, validateOTP } from '../../../../common/Utils';
import { MOBILE_NO_ERROR, INVALID_OTP_ERROR } from '../../../../common/constants';
import { FileUploadMUI } from "../../../../common/fileUpload/fileUploadMUI";
import { getLocalStorageItem } from "../../../../common/localStorageUtils";
import { PROD } from "../../../../common/constants";
import { CommonPincodeMUI } from '../../../../common/common-pincode/commonPincodeMUI';
import InputAdornment from '@mui/material/InputAdornment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import IconButton from "@mui/material/IconButton";
import BackButton from "../../../../common/backButton";
import { useTranslation } from "react-i18next";
import { TryOutlined } from "@mui/icons-material";
import { useHitContextData } from "./registrationDetailsHit";
import { DataGrid } from '@mui/x-data-grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Badge from 'react-bootstrap/Badge';
import { toast } from 'react-toastify';
import { insertComment } from '../commonRegistrationStakeholderAPIs';
import { handleNumberFieldFocus } from "../../../../common/commonFunction";
import { SaveIcon } from "../../../../common/icons";
import BadgeComponent from '../../../../common/badge';
import { addressMaxLength, emailUrnPassMaxLength, bankAccountNumber, mobileNoMaxLength, approverCommentMaxLength, govtIDcardLength, totalClumpsMaxLength, mobileNumberValidation, otpMaxLength, pincodeValidation, plotValidationForKatha, plotValidationForOtherUnits, totalNumberOfClumpValidation, totalPlotsMaxLength } from '../../../../common/commonValidations';
import apiClient from "../../../../axios";
import CommentIcon from '@mui/icons-material/Comment';



const BasicDetails = () => {
    const { userType, viewOnly, hitDetails, basicHitDetails, details, setBasicHitDetails, documentsArray, setDocumentsArray, bankDetails, setBankDetails, address, setAddress, otpValue, setOtpValue, verifyMobileNo, setVerifyMobileNo, otpHidden, setOtpHidden, mobileOTPValidated, setMobileOTPValidated, personalDetailsSectionOk, setPersonalDetailsSectionOk, bankDetailsSectionOk, setBankDetailsSectionOk, agreementDetailsSectionOk, setAgreementDetailsSectionOk, vehicleDetailsSectionOk, setVehicleDetailsSectionOk, shouldActOnSection, setShouldActOnSection, showWorkFlowButtons, showClarificationButton, enableSaveSubmitButtons, stakeHolderDetails, showCommentSection, commentsData, setCommentsData, registerByScruOtpValidated, comments, setComments, enableFieldFunction, currentPage, buttonAction, setCurrentPage, setButtonAction, errorMessage, setErrorMessage, expandedSection, setExpandedSection, setCallUpdateApi, callWorkFlowApi, regScruResourceUpdate, setRegScruResourceUpdate,
        isMSMERadio,
        setIsMSMERadio,
        msmeCategory,
        setMsmeCategory,
    } = useHitContextData();
    const navigate = useNavigate();
    const uuid = localStorage.getItem('uuid');
    const [characterLimit] = useState(300);
    const { t, i18n } = useTranslation();
    let userRole = localStorage.getItem('role');
    let personalComments = comments?.filter((item) => item.sectionName === "personal_details");
    let bankComments = comments?.filter((item) => item.sectionName === "bank_details");
    const [personalComment, setPersonalComment] = useState("");
    const [bankComment, setBankComment] = useState("");
    const decoded = jwt(getLocalStorageItem('id_token'));

    const MSME_CATEGORY_OPTIONS = [
        { key: "MSM1", description: "Micro:Goods Mnfg/Spl" },
        { key: "MSM2", description: "Micro:Service Provdr" },
        { key: "MSM3", description: "Small:Goods Mnfg/Spl" },
        { key: "MSM4", description: "Small:Service Provdr" },
        { key: "MSM5", description: "Medium:Good Mnfg/Spl" },
        { key: "MSM6", description: "Medium:Service Provdr" },
        { key: "MSM7", description: "Other:Goods Mnfg/Spl" },
        { key: "MSM8", description: "Other:Service Provdr" },
        { key: "OTHER", description: "Others" }
    ];

    useEffect(() => {
        if (basicHitDetails.applicantType === "Individual") {
            setIsMSMERadio("NO");
            setMsmeCategory("");
        }
    }, [basicHitDetails.applicantType]);

    const onUploadCallBack = (docArray) => {
        setDocumentsArray(docArray);
    }
    useEffect(() => {
        if (bankDetails) {
            setBasicHitDetails({
                ...basicHitDetails, bankBranch: bankDetails?.branch, bankName: bankDetails?.bank
            });
        }
    }, [bankDetails]);

    const onClickVerifyMobileNo = (e) => {
        e.preventDefault();
        setErrorMessage({ ...errorMessage, OTPError: "" });
        setOtpValue("");
        if (isValidMobileNumber(basicHitDetails.mobileNo)) {
            sendOTP(basicHitDetails.mobileNo, callBackMobileValidation);
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
        }
        else
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
    }
    const callBackMobileValidation = (response) => {
        setErrorMessage({ ...errorMessage, mobileNoError: "" });
        if (response.isSuccess) {
            setErrorMessage({ ...errorMessage, OTPSentError: "" })
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
            setVerifyMobileNo(true);
            setOtpHidden(false);
            setErrorMessage({ ...errorMessage, OTPError: "" });
        }

    }
    const onOtpChange = (e) => {
        const limit = 6;
        setOtpValue(e.target.value.slice(0, limit))
        if (e.target.value.length == 6) {
            validateOTP(basicHitDetails.mobileNo, e.target.value, callBackOTPValidation);
        }
    }
    const callBackOTPValidation = (response) => {
        setErrorMessage({ ...errorMessage, OTPSentError: "" });
        setErrorMessage({ ...errorMessage, mobileNoError: "" });
        if (response.isSuccess === true) {
            setVerifyMobileNo(false);
            setOtpHidden(true);
            setMobileOTPValidated(true);
            setErrorMessage({ ...errorMessage, OTPError: "" });
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
        }
        else {
            setErrorMessage({ ...errorMessage, mobileNoError: INVALID_OTP_ERROR });
        }
    }
    const isValidMobileNumber = (mobileNo) => {
        if (mobileNo.length == 10) {
            return true;
        }
        return false;
    }
    const handleChange = (e) => {
        setBasicHitDetails({ ...basicHitDetails, [e.target.name]: e.target.value });
        if (e.target.name === "contactPersonFirstName") {
            if ((e.target.value).length > 0) {
                setBasicHitDetails({ ...basicHitDetails, [e.target.name]: nameValidation(e.target.value) })
                setErrorMessage({ ...errorMessage, contactPersonFirstNameError: '' })
            }
        }
        if (e.target.name === "contactPersonMiddleName") {
            if ((e.target.value).length > 0) {
                setBasicHitDetails({ ...basicHitDetails, [e.target.name]: nameValidation(e.target.value) })
            } else return
        }
        if (e.target.name === "contactPersonLastName") {
            if ((e.target.value).length > 0) {
                setBasicHitDetails({ ...basicHitDetails, [e.target.name]: nameValidation(e.target.value) })
            } else return
        }
        if (e.target.name === 'govtIdCardNumber') {
            const limit = 4;
            const idlimit = (basicHitDetails?.certificateType === "Registration Certificate" || basicHitDetails?.certificateType === "MOA") ? 30 : 20;
            if (basicHitDetails.govtIdCardType === "Aadhaar ID") {
                setBasicHitDetails({ ...basicHitDetails, [e.target.name]: (e.target.value.slice(0, limit)) });
            }
            else {
                setBasicHitDetails({ ...basicHitDetails, [e.target.name]: (e.target.value.toUpperCase().slice(0, idlimit)) });
            }
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, govtIdCardNumberError: '' })
            }
        }

        if (e.target.name === 'emailId') {
            if ((e.target.value).length > 0) {
                if (emailValidation(e.target.value.slice(0, 50))) {
                    setErrorMessage({ ...errorMessage, emailIdError: "" })
                } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid Email Address" })
            }

        }
        if (e.target.name === 'address') {
            if ((e.target.value).length > 0) {
                setBasicHitDetails({ ...basicHitDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200)) })
                setErrorMessage({ ...errorMessage, addressError: " " })
            } else setErrorMessage({ ...errorMessage, addressError: "Please enter Address" })

        }
        if (e.target.name === 'bankAccountNumber') {
            const limit = 18;
            if (e.target.value.length > 0 && VALIDATION.bankAccountNumberValidation(e.target.value.slice(0, limit))) {
                setBasicHitDetails({ ...basicHitDetails, [e.target.name]: e.target.value.slice(0, limit) });
                setErrorMessage({ ...errorMessage, accountNumberError: '' })
            } else setErrorMessage({ ...errorMessage, accountNumberError: 'Please enter valid Account Number' })
        }
        if (e.target.name === 'govtIdCardNumber') {
            const limit = 4;
            if (e.target.value.length > 0) {
                if (basicHitDetails.govtIdCardType === "Aadhaar ID") {
                    setBasicHitDetails({ ...basicHitDetails, [e.target.name]: e.target.value.replace(/[^0-9]/gi, '').slice(0, limit) });

                }
                else {
                    setBasicHitDetails({ ...basicHitDetails, [e.target.name]: e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/gi, '') });
                    setErrorMessage({ ...errorMessage, govtIdCardNumberError: '' })
                }
            } else setErrorMessage({ ...errorMessage, govtIdCardNumberError: 'Please enter Address Proof ID' })
        }
        if (e.target.name === 'otherGovtCardType') {
            const limit = 50;
            if (e.target.value.length > 0) {
                setBasicHitDetails({ ...basicHitDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value).slice(0, limit) });
                setErrorMessage({ ...errorMessage, otherCardError: '' })
            }
            else {
                setErrorMessage({ ...errorMessage, otherCardError: 'Please enter ID Proof Name' })
            }
        }
        if (e.target.name === 'certificateNumber') {
            if (e.target.value.length > 0) {
                setBasicHitDetails({ ...basicHitDetails, [e.target.name]: e.target.value.toUpperCase().slice(0, 50).replace(/[^a-zA-Z0-9]/gi, '') });
                setErrorMessage({ ...errorMessage, certificateNumberError: '' })
            } else setErrorMessage({ ...errorMessage, certificateNumberError: 'Please enter ID Proof Number' })
        }
        //if (e.target.name === 'hitLabourLicenseNo') {
        //    if (e.target.value.length > 0) {
        //        setBasicHitDetails({ ...basicHitDetails, [e.target.name]: e.target.value.toUpperCase().slice(0, 50).replace(/[^a-zA-Z0-9]/gi, '') });
        //        setErrorMessage({ ...errorMessage, labourLicenseNoError: '' })
        //    } else setErrorMessage({ ...errorMessage, labourLicenseNoError: 'Please enter Labour License No' })
        //}
        if (e.target.name === 'bankAccountHolderName') {
            setBasicHitDetails({ ...basicHitDetails, bankAccountHolderName: VALIDATION.fullNameValidation(e.target.value) });
            if (e.target.value.length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setBasicHitDetails({ ...basicHitDetails, bankAccountHolderName: VALIDATION.fullNameValidation(e.target.value) });
                setErrorMessage({ ...errorMessage, accountHolderNameError: '' })
            } else setErrorMessage({ ...errorMessage, accountHolderNameError: "Please enter Account Holder's Name" })
        }
        if (e.target.name === 'panNumber') {
            setBasicHitDetails({ ...basicHitDetails, [e.target.name]: e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/gi, '') });
            if (e.target.value.length > 0 && VALIDATION.panNumberValidation(e.target.value.toUpperCase())) {
                setErrorMessage({ ...errorMessage, panNumberError: "" })
                setBasicHitDetails({ ...basicHitDetails, [e.target.name]: e.target.value.toUpperCase() });
            } else setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" })
        }
        if (e.target.name === 'bankIfscCode') {
            setBasicHitDetails({ ...basicHitDetails, [e.target.name]: e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/gi, '') });
            if (e.target.value.length > 0 && VALIDATION.ifscValidation(e.target.value.toUpperCase())) {
                setErrorMessage({ ...errorMessage, ifscCodeError: "" })
                setBasicHitDetails({ ...basicHitDetails, [e.target.name]: e.target.value, bankBranch: "" });
            } else setErrorMessage({ ...errorMessage, ifscCodeError: "Please enter valid IFSC Code" })
        }
    };

    const getUpdatedAddressData = (data) => {
        setBasicHitDetails({
            ...basicHitDetails,
            address: data, address,
            pincode: data.pincode,
            state: data.pincodeState,
            district: data.pincodeDistrict,
            subDivision: data.pincodeSubDivision,
            revenueCircle: data.selectedRevenueCircle,
            blockName: data.selectedBlockName,

        })
    }
    const getBankDetails = async () => {
        setErrorMessage({ ...errorMessage, ifscCodeError: "" })
        loaderService.showLoader()
        await apiClient
            .post(GET_ADDRESS_BY_IFSC,
                {
                    "ifsc": basicHitDetails?.bankIfscCode,
                },
                {
                    headers: {
                        AuthKey: authKey,
                    },
                }
            )
            .then((response) => {
                if (response.data.isSuccess === true) {
                    setBankDetails(response.data);
                    loaderService.hideLoader();
                }
                else {
                    setBasicHitDetails({
                        ...basicHitDetails,
                        bankIfscCode: "",
                        bankBranch: '',
                    })
                    loaderService.hideLoader()
                }
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
            });
    }
    const handleChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setBasicHitDetails({ ...basicHitDetails, blockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setBasicHitDetails({ ...basicHitDetails, revenueCircle: e.target.value, });
        }
    }

    const commentsColumn = [
        {
            field: 'comment', headerName: t('reg.comments'), width: 330,
            renderCell: (params) => {
                return (
                    <div style={{ wordBreak: "break-all", overflowWrap: "break-word", whiteSpace: "normal", minHeight: "auto" }}>
                        {params.value.split('<br />').map((line, index) => (
                            <>
                                {line}
                                <br />
                            </>
                        ))}
                    </div>
                )
            }
        },
        {
            field: 'createdByName', headerName: t('preReg.name'), width: 200
        },
        {
            field: 'userRole', headerName: t('reg.userRole'), width: 200
        },
        {
            field: 'createdOnFormatted', headerName: t('reg.date'), width: 200,
        },
    ]

    const onSaveComment = (comment, sectionName, sectionOk) => {
        const commentObject = {
            comment: comment,
            stakeholderMasterId: hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId,
            sectionName: sectionName,
            sectionId: hitDetails?.stakeHolder?.hitMasters[0]?.id,
            sectionOk: sectionOk,
            userRole: localStorage.getItem('role'),
            createdBy: decoded.extension_URN ? hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId : uuid,
        }
        comment ? insertComment([commentObject], hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId, setCommentsData) : toast.error("Please enter comment")
        setPersonalComment("");
        setBankComment("");
        // setBambooComment("");
        setErrorMessage({ ...errorMessage, personalCommentError: "", bankCommentError: "" });
    }

    return (
        <>
            {basicHitDetails && <>
                <Grid item xs={12}>
                    <Accordion mt={1} expanded={expandedSection === "personal"}
                        onChange={(event, expanded) => {
                            setExpandedSection(expanded ? "personal" : "");
                        }}>
                        <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (personalDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                        >
                            <Stack ml={2} display="flex" alignItems="center" direction="row">
                                {showCommentSection && !regScruResourceUpdate && (personalDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                                <Typography variant="subtitle1">{basicHitDetails.applicantType === "Individual" ? t('preReg.personalDetails') : t('preReg.organizationDetails')}</Typography>
                            </Stack>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (personalDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                                <Grid item xs={12} lg={6}>
                                    <Typography variant="subtitle2" gutterBottom>
                                        {t('preReg.applicantType')}
                                    </Typography>
                                    <ToggleButtonGroup
                                        style={{ display: "flex", overflow: "auto" }}
                                        color="primary"
                                        value={basicHitDetails?.applicantType || ''}
                                        exclusive
                                        onChange={(event, newValue) => {
                                            if (newValue !== null) {
                                                setBasicHitDetails({
                                                    ...basicHitDetails,
                                                    applicantType: newValue
                                                });
                                            }
                                        }}
                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                    >
                                        <ToggleButton value="Individual">Individual</ToggleButton>
                                        <ToggleButton value="Partnership">Partnership</ToggleButton>
                                        <ToggleButton value="Proprietorship">Proprietorship</ToggleButton>
                                        <ToggleButton value="Company">Company</ToggleButton>
                                    </ToggleButtonGroup>

                                </Grid>
                                {/* <Grid item xs={12} lg={4}>
                                    <TextField fullWidth
                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                        type="text"
                                        label={t('preReg.applicantType')}
                                        name="applicantType"
                                        value={basicHitDetails.applicantType}
                                        onChange={(e) => handleChange(e)}
                                        inputProps={{
                                            maxLength: maxNameLength

                                        }}
                                        error={errorMessage.applicantTypeError}
                                        helperText={errorMessage.applicantTypeError}
                                    />
                                </Grid> */}
                                <Grid item xs={12} lg={6} mt={2}>
                                    <TextField fullWidth
                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                        type="text"
                                        label={t('reg.fullName')}
                                        name="name"
                                        value={basicHitDetails.name}
                                        onChange={(e) => handleChange(e)}
                                        inputProps={{
                                            maxLength: maxNameLength,

                                        }}
                                        error={errorMessage.fullNameError}
                                        helperText={errorMessage.fullNameError}
                                    />
                                    <BadgeComponent currentLength={basicHitDetails?.name?.length} maxLength={maxNameLength} />
                                </Grid>
                                {basicHitDetails.applicantType !== "Individual" && (
                                    <Grid item xs={12} lg={2}>
                                        <FormControl>
                                            <FormLabel sx={{ fontWeight: 600 }}>
                                                Is MSME?
                                            </FormLabel>

                                            <ToggleButtonGroup
                                                exclusive
                                                value={isMSMERadio}
                                                onChange={(e, value) => value && setIsMSMERadio(value)}
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                                sx={{ mt: 1 }}
                                            >
                                                <ToggleButton value="YES">Yes</ToggleButton>
                                                <ToggleButton value="NO">No</ToggleButton>
                                            </ToggleButtonGroup>
                                        </FormControl>
                                    </Grid>
                                )}
                                {basicHitDetails.applicantType !== "Individual" && isMSMERadio === "YES" && (
                                    <Grid item xs={12} lg={4} mt={3}>
                                        <FormControl fullWidth>
                                            <InputLabel>MSME Category</InputLabel>
                                            <Select
                                                label="MSME Category"
                                                value={msmeCategory}
                                                onChange={(e) => setMsmeCategory(e.target.value)}
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                            >
                                                {MSME_CATEGORY_OPTIONS.map(option => (
                                                    <MenuItem key={option.key} value={option.key}>
                                                        <strong>{option.key}</strong> — {option.description}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                )}
                                {basicHitDetails.applicantType !== "Individual" && isMSMERadio === "YES" && (
                                    <Grid item xs={12} lg={6} mt={2}>
                                        <FileUploadMUI
                                            key="MSME_Certificate"
                                            documentList={documentsArray}
                                            documentType="MSME_Certificate"
                                            callBackDocumentUpload={onUploadCallBack}
                                            stakeholderDetailId={
                                                hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId
                                            }
                                            title="Upload MSME Certificate"
                                            stakeHolderType="hit"
                                            disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                            errorMessage={errorMessage}
                                            setErrorMessage={setErrorMessage}
                                            documentError="msmeDocError"
                                        />
                                    </Grid>
                                )}

                                <Grid item xs={12}>
                                    <Typography variant="h6" gutterBottom>
                                        {t('preReg.contactPersonDetails')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4} lg={2}>
                                    <FormControl fullWidth>
                                        <InputLabel>{t('preReg.salutation')}</InputLabel>
                                        <Select
                                            label={t('preReg.salutation')}
                                            disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                            name='contactPersonSalutation'
                                            onChange={(e) => handleChange(e)}
                                            value={basicHitDetails.contactPersonSalutation}>
                                            {SALUTATION.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={8} lg={4}>
                                    <TextField fullWidth
                                        required
                                        error={errorMessage.contactPersonFirstNameError}
                                        helperText={errorMessage.contactPersonFirstNameError}
                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                        type="text"
                                        name="contactPersonFirstName"
                                        label={t('preReg.firstname')}
                                        value={basicHitDetails?.contactPersonFirstName}
                                        onChange={(e) => handleChange(e)}
                                        inputProps={{
                                            maxLength: maxNameLength

                                        }}
                                    />
                                    <BadgeComponent currentLength={basicHitDetails?.contactPersonFirstName?.length} maxLength={maxNameLength} />

                                </Grid>
                                <Grid item xs={6} lg={3}>
                                    <TextField fullWidth
                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                        type="text"
                                        name="contactPersonMiddleName"
                                        label={t('preReg.middlename')}
                                        value={basicHitDetails.contactPersonMiddleName}
                                        onChange={(e) => handleChange(e)}
                                        inputProps={{
                                            maxLength: maxNameLength
                                        }}
                                    />
                                    <BadgeComponent currentLength={basicHitDetails?.contactPersonMiddleName?.length} maxLength={maxNameLength} />
                                </Grid>
                                <Grid item xs={6} lg={3}>
                                    <TextField fullWidth
                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                        type="text"
                                        name="contactPersonLastName"
                                        label={t('preReg.lastname')}
                                        value={basicHitDetails.contactPersonLastName}
                                        onChange={(e) => handleChange(e)}
                                        inputProps={{
                                            maxLength: maxNameLength
                                        }}
                                    />
                                    <BadgeComponent currentLength={basicHitDetails?.contactPersonLastName?.length} maxLength={maxNameLength} />
                                </Grid>
                                <Grid item xs={4} lg={2}>
                                    <FormControl fullWidth error={errorMessage?.genderError}>
                                        <InputLabel>{t('preReg.gender')}</InputLabel>
                                        <Select
                                            required
                                            label={t('preReg.gender')}
                                            name='contactPersonGender'
                                            disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                            value={basicHitDetails.contactPersonGender}
                                            onChange={(e) => handleChange(e)}
                                        >

                                            {GENDER.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                        </Select>
                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage?.genderError}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={8} lg={4}>
                                    <TextField fullWidth required error={errorMessage.mobileNoError} helperText={errorMessage.mobileNoError} type="number" onFocus={handleNumberFieldFocus} label={t('preReg.mobileNo')} name="mobileNo"
                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)} value={basicHitDetails?.mobileNo} onChange={(e) => handleChange(e)} />
                                    {verifyMobileNo === true ?
                                        <div>
                                            <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</a></div>
                                        : hitDetails?.stakeHolder?.isOtpValidated === true ?
                                            <div className="commonVerifyText"><a href="#" style={{ marginLeft: "1vw" }}>Verified</a>
                                                <img className="commonOtpImg" src={resolveIcon} alt="" /></div> : mobileOTPValidated === true ? <div hidden={!mobileOTPValidated}><a className="otp-linklle" href="#">Verified</a>
                                                    <img className="commonOtpImg" src={resolveIcon} alt="" /></div> :
                                                <button className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Verify Mobile no.</button>
                                    }
                                </Grid>
                                {verifyMobileNo &&
                                    <Grid item xs={3} lg={2}>
                                        <TextField fullWidth type="number" onFocus={handleNumberFieldFocus} onChange={(e) => onOtpChange(e)} value={otpValue} label={t('preReg.otp')} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                                    </Grid>}
                                <Grid item xs={12} lg={6}>
                                    <TextField fullWidth
                                        required
                                        error={errorMessage.emailIdError}
                                        helperText={errorMessage.emailIdError}
                                        type="text"
                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                        label={t('main.email')}
                                        name="emailId"
                                        value={basicHitDetails.emailId}
                                        onChange={(e) => handleChange(e)} />
                                    <BadgeComponent currentLength={basicHitDetails?.emailId?.length} maxLength={emailUrnPassMaxLength} />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <TextField fullWidth
                                        required
                                        error={errorMessage.panNumberError}
                                        helperText={errorMessage.panNumberError}
                                        type="text"
                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                        label={t('reg.panNumber')}
                                        name="panNumber"
                                        value={basicHitDetails?.panNumber}
                                        onChange={(e) => handleChange(e)}
                                        InputProps={{
                                            maxLength: 10,
                                            style: { textTransform: "uppercase" }
                                        }}

                                    />
                                    <BadgeComponent currentLength={basicHitDetails?.panNumber?.length} maxLength={govtIDcardLength} />
                                    <FileUploadMUI key="PANCard"
                                        documentList={documentsArray}
                                        documentType="PANCard"
                                        callBackDocumentUpload={onUploadCallBack}
                                        stakeholderDetailId={hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId}
                                        title={t('preReg.uploadPanDoc')}
                                        stakeHolderType="hit"
                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                        errorMessage={errorMessage}
                                        setErrorMessage={setErrorMessage}
                                        documentError="panDocError"
                                    />
                                    {/* <div className='mandatory_field'>{errorMessage.panDocError}</div> */}
                                </Grid>
                                <Grid item xs={6} lg={4}>
                                    <FormControl fullWidth>
                                        <InputLabel>{t('preReg.idProof')}</InputLabel>
                                        <Select
                                            label={t('preReg.idProof')}
                                            required
                                            error={errorMessage.idProofError}
                                            helperText={errorMessage.idProofError}
                                            name="certificateType"
                                            disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                            value={basicHitDetails.certificateType}
                                            onChange={(e) => handleChange(e)} >
                                            <MenuItem disabled value=""> Certificate Type</MenuItem>
                                            {CONSTANTS.ID_PROOF_ARRAY.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                        </Select>
                                        <div className='mandatory_field'>{errorMessage.idProofError}</div>
                                    </FormControl>
                                </Grid>
                                {basicHitDetails?.certificateType === "Other" &&
                                    <Grid item xs={6} lg={4}>
                                        <TextField fullWidth
                                            disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                            type="text"
                                            label={t('preReg.enterIdProof')} name="otherGovtCardType"
                                            value={basicHitDetails?.otherGovtCardType}
                                            onChange={(e) => handleChange(e)}
                                            InputProps={{
                                                style: { textTransform: "uppercase" }
                                            }}
                                        />

                                    </Grid>}
                                <Grid item xs={12} lg={4}>
                                    <TextField fullWidth
                                        required
                                        error={errorMessage.certificateNumberError}
                                        helperText={errorMessage.certificateNumberError}
                                        type="text"
                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                        label={basicHitDetails?.certificateType === "MOA" ? t('preReg.enterMOA') : basicHitDetails?.certificateType === "Registration Certificate" ? t('preReg.enterRegNo') : basicHitDetails?.certificateType === "GST" ? t('preReg.enterGSTNo') : t('preReg.enterNo')}
                                        name="certificateNumber"
                                        value={basicHitDetails.certificateNumber} onChange={(e) => handleChange(e)}
                                        InputProps={{
                                            maxLength: (basicHitDetails?.certificateType === "Registration Certificate" || basicHitDetails?.certificateType === "MOA") ? 30 : 20,
                                            style: { textTransform: "uppercase" }
                                        }}
                                        style={{ textTransform: "uppercase" }} />
                                    <FileUploadMUI key="MOA_RegistrationCertificate"
                                        documentList={documentsArray}
                                        documentType="MOA_RegistrationCertificate"
                                        callBackDocumentUpload={onUploadCallBack}
                                        stakeholderDetailId={hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId}
                                        title={t('reg.uploadIDProofDoc')}
                                        stakeHolderType="hit"
                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                        errorMessage={errorMessage}
                                        setErrorMessage={setErrorMessage}
                                        documentError="idProofDocError"
                                    />
                                    {/* <div className='mandatory_field'>{errorMessage.idProofDocError}</div> */}
                                </Grid>
                                {basicHitDetails.applicantType === "Individual" ?
                                    <>
                                        <Grid item xs={6} lg={4}>
                                            <FormControl fullWidth>
                                                <InputLabel>{t('preReg.addressProof')}</InputLabel>
                                                <Select
                                                    required
                                                    label={t('preReg.addressProof')}
                                                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                    name="govtIdCardType"
                                                    value={basicHitDetails?.govtIdCardType}
                                                    onChange={(e) => handleChange(e)}>
                                                    {CONSTANTS.GOV_ID_LIST.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} lg={4}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.govtIdCardNumberError}
                                                helperText={errorMessage.govtIdCardNumberError}
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                type="text"
                                                label={basicHitDetails.govtIdCardType === "Aadhaar ID" ? t('preReg.enterLast4digit') : basicHitDetails.govtIdCardType === "Voter ID" ? t('preReg.enterVoterId') : basicHitDetails.govtIdCardType === "Driving Licence" ? t('preReg.enterDrivinglicense') : t('preReg.enterBankPassbookNo')}
                                                name="govtIdCardNumber"
                                                value={basicHitDetails.govtIdCardNumber}
                                                onChange={(e) => handleChange(e)}
                                                InputProps={{
                                                    maxLength: (basicHitDetails?.certificateType === "Registration Certificate" || basicHitDetails?.certificateType === "MOA") ? 30 : 20,
                                                    style: { textTransform: "uppercase" }
                                                }}
                                            />
                                            <BadgeComponent currentLength={basicHitDetails?.govtIdCardNumber?.length} maxLength={lastFourDigit} />
                                            <FileUploadMUI key="IDProof"
                                                documentList={documentsArray}
                                                documentType="IDProof"
                                                callBackDocumentUpload={onUploadCallBack}
                                                stakeholderDetailId={hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId}
                                                title={t('reg.uploadAddressProofDoc')}
                                                stakeHolderType="hit"
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="addressProofDocError"
                                            />
                                            {/* <div className='mandatory_field'>{errorMessage.addressProofDocError}</div> */}
                                        </Grid>
                                    </> :
                                    <>
                                        <Grid item xs={6} lg={4}>
                                            <FormControl fullWidth>
                                                <InputLabel>{t('preReg.addressProof')}</InputLabel>
                                                <Select
                                                    label={t('preReg.addressProof')}
                                                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                    name="govtIdCardType"
                                                    value={basicHitDetails.govtIdCardType} onChange={(e) => handleChange(e)}>
                                                    {/* <MenuItem disabled> Address Proof</MenuItem> */}
                                                    {CONSTANTS.ID_PROOF_ARRAY.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.govtIdCardNumberError}
                                                helperText={errorMessage.govtIdCardNumberError}
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                type="text"
                                                label={basicHitDetails?.certificateType === "MOA" ? t('preReg.enterMOA') : basicHitDetails?.certificateType === "Registration Certificate" ? t('preReg.enterRegNo') : basicHitDetails?.certificateType === "GST" ? t('preReg.enterGSTNo') : t('preReg.enterNo')}
                                                name="govtIdCardNumber"
                                                value={basicHitDetails.govtIdCardNumber}
                                                onChange={(e) => handleChange(e)}
                                                InputProps={{
                                                    maxLength: (basicHitDetails?.certificateType === "Registration Certificate" || basicHitDetails?.certificateType === "MOA") ? 30 : 20,
                                                    style: { textTransform: "uppercase" }
                                                }} />
                                            <BadgeComponent currentLength={basicHitDetails?.govtIdCardNumber?.length} maxLength={govtIDcardLength} />
                                            <FileUploadMUI key="IDProof"
                                                documentList={documentsArray}
                                                documentType="IDProof"
                                                callBackDocumentUpload={onUploadCallBack}
                                                stakeholderDetailId={hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId}
                                                title={t('reg.uploadAddressProofDoc')}
                                                stakeHolderType="hit"
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="addressProofDocError"
                                            />
                                            {/* <div className='mandatory_field'>{errorMessage.addressProofDocError}</div> */}
                                        </Grid>
                                    </>
                                }
                                <Grid item xs={12}>
                                    <TextField fullWidth
                                        required
                                        error={errorMessage.addressError}
                                        helperText={errorMessage.addressError}
                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                        type="text"
                                        label={t('main.address')}
                                        name="address"
                                        multiline
                                        value={basicHitDetails?.address}
                                        onChange={(e) => handleChange(e)}
                                        inputProps={{
                                            maxLength: addressMaxLength
                                        }} />
                                    <BadgeComponent currentLength={basicHitDetails?.address?.length} maxLength={addressMaxLength} />
                                </Grid>
                                <CommonPincodeMUI setErrorMessage={setErrorMessage}
                                    fullWidth={true}
                                    revenueNotRequired={true}
                                    isDisabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                    pincode={basicHitDetails.pincode}
                                    state={basicHitDetails.state}
                                    district={basicHitDetails.district}
                                    revenueCircle={basicHitDetails.revenueCircle}
                                    blockName={basicHitDetails.blockName}
                                    onHandleCallback={getUpdatedAddressData}
                                    pincodeError={errorMessage.pincodeError}
                                    searchError={errorMessage.searchError}
                                    handleChangeSelect={handleChangeSelect}
                                />
                            </Grid>
                            {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                                <Grid item xs={7}>
                                    <TextField sx={{ width: "100%" }}
                                        label={t('reg.comment')}
                                        helperText={errorMessage.personalCommentError}
                                        error={errorMessage.personalCommentError}
                                        name="comment"
                                        inputProps={{
                                            maxLength: 300,
                                        }}
                                        multiline
                                        disabled={!shouldActOnSection.personal_details || viewOnly}
                                        value={personalComment}
                                        onChange={(e) => setPersonalComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                                    />
                                    {/* <BadgeComponent currentLength={basicHitDetails?.plotComment?.length} maxLength={approverCommentMaxLength} /> */}
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                        <Badge bg={`${personalComment?.length > characterLimit ? 'danger' : 'primary'}`}>{personalComment?.length}/{characterLimit}</Badge>
                                    </div>
                                </Grid>
                                <Grid item xs={2}>
                                    <FormGroup>
                                        <FormControlLabel control={<Switch disabled={!shouldActOnSection.personal_details || viewOnly} checked={personalDetailsSectionOk}
                                            onChange={(e) => setPersonalDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                                                {t('reg.detailsOk')}?
                                            </Typography>} />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={3}>
                                    <Button variant="contained" disabled={!shouldActOnSection.personal_details || viewOnly}
                                        onClick={() => onSaveComment(personalComment, "personal_details", personalDetailsSectionOk)}
                                        startIcon={<CommentIcon />}
                                    >
                                        {t('preReg.addComment')}
                                    </Button>
                                </Grid>
                            </Grid>
                                <div>
                                    <Accordion mt={1} >
                                        <AccordionSummary
                                            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                        >
                                            <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Box style={{ height: 300, width: '100%' }}>
                                                <DataGrid
                                                    rows={personalComments ? personalComments : []}
                                                    columns={commentsColumn}
                                                    pageSize={10}
                                                    getRowHeight={() => 'auto'} />
                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>
                                </div></>}
                        </AccordionDetails>

                    </Accordion>
                </Grid>
                <Grid item xs={12}>
                    <Accordion mt={1} expanded={expandedSection === "bank"}
                        onChange={(event, expanded) => {
                            setExpandedSection(expanded ? "bank" : "");
                        }}>
                        <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (bankDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                        >
                            <Stack ml={2} display="flex" alignItems="center" direction="row">
                                {showCommentSection && !regScruResourceUpdate && (bankDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                                <Typography variant="subtitle1">{t('preReg.bankDetails')}</Typography>
                            </Stack>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container pb={3} pr={4} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (bankDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                                <Grid item xs={12} lg={6}>
                                    <TextField fullWidth
                                        required
                                        error={errorMessage.accountNumberError}
                                        helperText={errorMessage.accountNumberError}
                                        disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                                        type="number"
                                        onFocus={handleNumberFieldFocus}
                                        label={t('preReg.accountNo')}
                                        name="bankAccountNumber"
                                        value={basicHitDetails?.bankAccountNumber}
                                        onChange={(e) => handleChange(e)}
                                        inputProps={{
                                            maxLength: 20
                                        }}
                                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                    />
                                    <BadgeComponent currentLength={basicHitDetails?.bankAccountNumber?.length} maxLength={bankAccountNumber} />
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <TextField fullWidth required error={errorMessage.accountHolderNameError} helperText={errorMessage.accountHolderNameError} disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)} type="text" label={t('preReg.accountHolderName')} name="bankAccountHolderName" value={basicHitDetails?.bankAccountHolderName} onChange={(e) => handleChange(e)} inputProps={{
                                        maxLength: maxNameLength
                                    }} />
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <TextField fullWidth
                                        required
                                        error={errorMessage.ifscCodeError}
                                        helperText={errorMessage.ifscCodeError}
                                        type="text"
                                        disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                                        name="bankIfscCode"
                                        label={t('preReg.ifscCode')}
                                        value={basicHitDetails.bankIfscCode || ''}
                                        onChange={(e) => handleChange(e)}
                                        onKeyDown={(evt) => (evt.key === '.' || evt.key === '-') && evt.preventDefault()}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton color='primary' disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)} aria-label="delete" onClick={() => getBankDetails()}>
                                                        <SearchIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            maxLength: 11
                                        }}
                                    ></TextField>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <TextField fullWidth type="text" label={t('preReg.branch')} name="bankAccountHolbankBranchderName" value={basicHitDetails?.bankBranch} onChange={(e) => handleChange(e)} disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)} />

                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <FileUploadMUI key={BANK_CANCELLED_CHEQUE}
                                        documentList={documentsArray}
                                        documentType={BANK_CANCELLED_CHEQUE}
                                        callBackDocumentUpload={onUploadCallBack}
                                        stakeholderDetailId={hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId}
                                        title={t('preReg.uploadPassbookCancelledCheck')}
                                        stakeHolderType="hit"
                                        disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                                        errorMessage={errorMessage}
                                        setErrorMessage={setErrorMessage}
                                        documentError="bankDocError"
                                    />
                                    {/* <div className='mandatory_field'>{errorMessage.bankDocError}</div> */}
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <FileUploadMUI key="BankStatement"
                                        documentList={documentsArray}
                                        documentType="BankStatement"
                                        callBackDocumentUpload={onUploadCallBack}
                                        stakeholderDetailId={hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId}
                                        title={t('reg.uploadLast6monthsBankStatement')}
                                        stakeHolderType="hit"
                                        disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                                        errorMessage={errorMessage}
                                        setErrorMessage={setErrorMessage}
                                        documentError="bankStatementError"
                                    />
                                    {/* <div className='mandatory_field'>{errorMessage.bankStatementError}</div> */}
                                </Grid>
                            </Grid>
                            {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                                <Grid item xs={7}>
                                    <TextField sx={{ width: "100%" }}
                                        label={t('reg.comment')}
                                        helperText={errorMessage.bankCommentError}
                                        error={errorMessage.bankCommentError}
                                        name="comment"
                                        inputProps={{
                                            maxLength: 300,
                                        }}
                                        multiline
                                        disabled={!shouldActOnSection.bank_details || viewOnly}
                                        value={bankComment}
                                        onChange={(e) => setBankComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                                    />
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                        <Badge bg={`${bankComment?.length > characterLimit ? 'danger' : 'primary'}`}>{bankComment?.length}/{characterLimit}</Badge>
                                    </div>
                                </Grid>
                                <Grid item xs={2}>
                                    <FormGroup>
                                        <FormControlLabel control={<Switch disabled={!shouldActOnSection.bank_details || viewOnly} checked={bankDetailsSectionOk}
                                            onChange={(e) => setBankDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                                                {t('reg.detailsOk')}?
                                            </Typography>} />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={3}>
                                    <Button variant="contained" disabled={!shouldActOnSection.bank_details || viewOnly}
                                        onClick={() => onSaveComment(bankComment, "bank_details", bankDetailsSectionOk)}
                                        startIcon={<CommentIcon />}
                                    >
                                        {t('preReg.addComment')}
                                    </Button>
                                </Grid>
                            </Grid>
                                <div>
                                    <Accordion mt={1} >
                                        <AccordionSummary
                                            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                        >
                                            <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Box style={{ height: 300, width: '100%' }}>
                                                <DataGrid
                                                    rows={bankComments ? bankComments : []}
                                                    columns={commentsColumn}
                                                    pageSize={10}
                                                    getRowHeight={() => 'auto'} />
                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>
                                </div></>}
                        </AccordionDetails>

                    </Accordion>
                </Grid>
            </>}
        </>
    )

}
export default BasicDetails;

